import React from 'react';
import styled from 'styled-components';
import {
  CheckOutlined,
  ExclamationOutlined,
  LoadingOutlined,
} from '@ant-design/icons';
import { COLOR, FONT_SIZE, SPACING } from '../../../constants/theme';

const TONE_STYLE = {
  success: {
    accent: COLOR.success,
    background: COLOR.successBackground,
    icon: CheckOutlined,
  },
  pending: {
    accent: COLOR.primary,
    background: COLOR.primaryLight,
    icon: LoadingOutlined,
  },
  warning: {
    accent: COLOR.warning,
    background: COLOR.warningBackground,
    icon: ExclamationOutlined,
  },
  error: {
    accent: COLOR.errorText,
    background: COLOR.errorBackground,
    icon: ExclamationOutlined,
  },
};

const Container = styled.header`
  margin: ${SPACING.xxl} 0;
  text-align: center;
`;

const IconCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  margin: 0 auto ${SPACING.lg};
  border-radius: 50%;
  background: ${({ background }) => background};

  .anticon {
    font-size: 24px;
    color: ${({ accent }) => accent};
  }
`;

const Title = styled.h1`
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: ${COLOR.navy};
`;

const Subtitle = styled.p`
  margin: ${SPACING.sm} auto 0;
  max-width: 34em;
  font-size: ${FONT_SIZE.value};
  line-height: 1.55;
  color: ${COLOR.textSecondary};
`;

const ResultHero = ({ tone = 'success', icon, title, subtitle }) => {
  const {
    accent,
    background,
    icon: ToneIcon,
  } = TONE_STYLE[tone] || TONE_STYLE.success;

  return (
    <Container>
      <IconCircle accent={accent} background={background}>
        {icon || <ToneIcon />}
      </IconCircle>
      <Title>{title}</Title>
      {subtitle && <Subtitle>{subtitle}</Subtitle>}
    </Container>
  );
};

export default ResultHero;
